import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=2aa7ecc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.2.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa7ecc4"]])

export default __exports__